import React, { useState, useEffect } from "react";
import { FiHash, FiHome } from "react-icons/fi";
import InputField from "../../../ResuableCompoment/InputField";
import SelectField from "../../../ResuableCompoment/SelectField";
import Statemaster from "../../../../DummyJson/Statemaster.json";
import useApi from "../../../CustomHooks/useApi";

const AadhaarDetails = ({ data, onUpdate, onErrorUpdate }) => {
  const [errors, setErrors] = useState({});
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(true);
  const [isVerifying, setIsVerifying] = useState(false);

  const [formData, setFormData] = useState({
    aadharNumber: data.aadharNumber || "",
    state: data.state || "",
    district: data.district || "",
    houseAddress: data.houseAddress || "",
    landmark: data.landmark || "",
    pincode: data.pincode || "",
  });

  const { callApi: aadhaarverify } = useApi(`/staff/onboard/verify/adhaar`, "GET");

  useEffect(() => {
    setFormData({
      aadharNumber: data.aadharNumber || "",
      state: data.state || "",
      district: data.district || "",
      houseAddress: data.houseAddress || "",
      landmark: data.landmark || "",
      pincode: data.pincode || "",
    });
  }, [data]);

  const validate = (name, value) => {
    let error = "";
    if (!value.trim()) return "";
    if (name === "houseAddress" && value.length > 1000)
      error = "House Address cannot exceed 100 characters.";
    if (name === "landmark" && value.length > 1000)
      error = "Landmark cannot exceed 100 characters.";
    return error;
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    const errorMsg = validate(name, value);


    if (name === "aadharNumber") {
      value = value.replace(/\D/g, "").slice(0, 12);
    }

    setErrors((prev) => {
      const updatedErrors = { ...prev, [name]: errorMsg || "" };
      if (onErrorUpdate) {
        onErrorUpdate(updatedErrors);
      }
      return updatedErrors;
    });

    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    onUpdate(updatedFormData);
  };

  const handleAadhaarVerify = async () => {
    setIsVerifying(true);
    try {
      const response = await aadhaarverify(null, `?adhaar=${formData.aadharNumber}`);
      if (response === true) {
        setIsAadhaarVerified(true);
        alert("Aadhaar verified successfully.");
      } else {
        setIsAadhaarVerified(false);
        alert("Aadhaar Not Valid.");
      }
    } catch {
      setIsAadhaarVerified(false);
      alert("Aadhaar verification failed.");
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="w-full min-h-[500px]">

      {/* SECTION TITLE */}
      <h3 className="text-lg font-semibold text-[#0A2A4F] mb-6">
        Aadhaar Information
      </h3>

      {/* INPUT GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Aadhaar Number + Verify */}
        <div className="md:col-span-2 flex gap-4 items-end">
          <div className="flex-1">
            <InputField
              type="text"
              label={<span>Aadhaar Number *</span>}
              icon={FiHash}
              value={formData.aadharNumber}
              onChange={handleChange}
              maxLength={12}
              name="aadharNumber"
              placeholder="Enter Aadhaar Number"
            />
          </div>

          {data?.role === undefined && !isAadhaarVerified && (
            <button
              type="button"
              onClick={handleAadhaarVerify}
              disabled={isVerifying}
              className="h-[46px] px-6 rounded-full bg-[#0A2A4F] text-white hover:bg-[#08305e]"
            >
              {isVerifying ? "Verifying..." : "Verify"}
            </button>
          )}
        </div>

        {(data?.role !== undefined || isAadhaarVerified) && (
          <>
            <SelectField
              label={<span>State *</span>}
              name="state"
              value={formData.state}
              onChange={handleChange}
              options={Statemaster.states.map((s) => ({
                value: s.state,
                label: s.state,
              }))}
            />

            <SelectField
              label={<span>District *</span>}
              name="district"
              value={formData.district}
              onChange={handleChange}
              options={
                Statemaster.states
                  .find((s) => s.state === formData.state)
                  ?.districts.map((d) => ({
                    value: d,
                    label: d,
                  })) || []
              }
            />

            <InputField
              type="text"
              label={<span>House Address *</span>}
              icon={FiHome}
              value={formData.houseAddress}
              onChange={handleChange}
              name="houseAddress"
            />

            <InputField
              type="text"
              label={<span>Landmark *</span>}
              icon={FiHome}
              value={formData.landmark}
              onChange={handleChange}
              name="landmark"
            />

            <InputField
              type="text"
              label={<span>Pincode *</span>}
              icon={FiHash}
              value={formData.pincode}
              onChange={handleChange}
              name="pincode"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default AadhaarDetails;
